module.exports = __webpack_public_path__ + "img/walet.9d5e071d.png";